import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase.js';
import { TIER_LEVELS } from './tierSystem.js';

export const updateUserTier = async (userId, newTier) => {
  try {
    if (!TIER_LEVELS[newTier]) {
      throw new Error('Invalid tier level');
    }

    const userRef = doc(db, 'users', userId);
    await updateDoc(userRef, {
      tier: newTier,
      tierUpdatedAt: new Date().toISOString(),
      benefits: TIER_LEVELS[newTier].benefits
    });

    return {
      success: true,
      newTier,
      benefits: TIER_LEVELS[newTier].benefits
    };
  } catch (error) {
    console.error('Error updating user tier:', error);
    throw error;
  }
}; 